import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'SectionHeader' })((theme) => ({
  root: {
    width: '100%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  titleStack: {
    minWidth: 0,
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
  },
  iconWrapper: {
    display: 'inline-flex',
    flexShrink: 0,
    alignItems: 'center',
  },
  titleWrapper: {
    minWidth: 0,
    flex: 1,
    overflow: 'hidden',
  },
  title: {
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  },
}));
